<textarea
	#input
	name=""
	id=""
	[value]="value"
	[placeholder]="placeholder"
	[cols]="cols"
	[rows]="rows"
	(keyup)="onChange(input.value)"
	(keyup.enter)="onEnter(input.value)"
	(focusin)="onFocusIn(input.value)"
	(focusout)="onFocusOut(input.value)"
>{{value}}</textarea>
